import React, { useEffect } from "react";
import { useI18n } from "@/i18n/I18nContext";

function LegalPage({ tKey, sections, testid }) {
  const { t, lang } = useI18n();

  useEffect(() => {
    document.title = `${t(`${tKey}.title`)} — Monderavello`;
    document.documentElement.setAttribute("lang", lang === "mx" ? "es-MX" : "en");
  }, [lang, tKey, t]);

  return (
    <main data-testid={testid} className="bg-white">
      <div className="bg-[#F1F5F9] border-b border-[#E2E8F0]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <p className="text-xs font-mono uppercase tracking-widest text-[#2A6B7C]">
            Monderavello · México
          </p>
          <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-[#0F2942]">
            {t(`${tKey}.title`)}
          </h1>
          <p className="mt-3 text-sm text-[#475569]">{t(`${tKey}.updated`)}</p>
        </div>
      </div>
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 space-y-8">
        <p className="text-base text-[#334155] leading-relaxed">
          {t(`${tKey}.intro`)}
        </p>
        {sections.map((n) => (
          <section key={n} className="space-y-2">
            <h2 className="text-xl sm:text-2xl font-semibold text-[#0F2942]">
              {t(`${tKey}.s${n}_title`)}
            </h2>
            <p className="text-base text-[#334155] leading-relaxed">
              {t(`${tKey}.s${n}_body`)}
            </p>
          </section>
        ))}
      </article>
    </main>
  );
}

export function PrivacyPolicy() {
  return <LegalPage tKey="privacy" sections={[1, 2, 3, 4, 5, 6, 7]} testid="privacy-page" />;
}

export function CookiePolicy() {
  return <LegalPage tKey="cookies" sections={[1, 2, 3, 4, 5]} testid="cookies-page" />;
}

export function Terms() {
  return <LegalPage tKey="terms" sections={[1, 2, 3, 4, 5, 6]} testid="terms-page" />;
}
